import { createAction, props } from "@ngrx/store";
import { CountryInterface } from "../../interfaces";

export const setCountries = createAction(
  "[Countries] Set Countries",
  props<{ countries: CountryInterface[] }>()
);
